import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/auth-module/rl-logo.svg'


const _hoisted_1 = { class: "flex bg-white h-screen" }
const _hoisted_2 = { class: "w-1/2 flex flex-col mt-[6rem] items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "w-12 h-12"
}, null, -1)
const _hoisted_4 = { class: "text-3xl font-semibold mt-5" }
const _hoisted_5 = { class: "font-normal text-base mt-1" }
const _hoisted_6 = { class: "w-[50%]" }
const _hoisted_7 = {
  key: 0,
  class: "mt-6 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
}
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex justify-center mt-6" }
const _hoisted_11 = { class: "text-sm text-gray-600 font-normal" }
const _hoisted_12 = {
  key: 1,
  class: "flex justify-center mt-3"
}
const _hoisted_13 = { class: "flex h-full items-end w-full pl-5 pb-5" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("section", { class: "w-1/2 bg-gray-300" }, null, -1)

import router from "@/router";
import { auth } from "@/utils/firebase";
import { confirmPasswordReset, signInWithEmailAndPassword, verifyPasswordResetCode } from "firebase/auth";
import { markRegionReauthDone } from "@/lib/runtime-url-resolver";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

const route = useRoute();
const email = ref("");
const oobCode = ref("");
const isSubmitting = ref(false);
const linkInvalid = ref(false);

const goToLogin = () => {
  router.push("/auth/login");
};

const goToForgotPassword = () => {
  router.push("/auth/forgot-password");
};

const resolveResetCode = async () => {
  const code = String(route.query.oobCode || "");
  if (!code) {
    linkInvalid.value = true;
    return;
  }

  oobCode.value = code;
  email.value = String(route.query.email || "");

  try {
    const verifiedEmail = await verifyPasswordResetCode(auth, code);
    if (!email.value) {
      email.value = verifiedEmail;
    }
  } catch (error) {
    console.error("Invalid or expired reset code:", error);
    linkInvalid.value = true;
  }
};

const handleSubmit = async (value: any) => {
  if (linkInvalid.value || !oobCode.value) {
    return;
  }

  isSubmitting.value = true;
  try {
    await confirmPasswordReset(auth, oobCode.value, value.password);

    if (email.value) {
      await signInWithEmailAndPassword(auth, email.value, value.password);
      // This signs in without going through userStore.login(), so stamp the region
      // re-auth marker here too: otherwise the router guard would immediately sign the
      // admin back out, right after they set a new password.
      markRegionReauthDone();
    }

    router.push("/");
  } catch (error: any) {
    console.error("Error resetting password:", error);
    alert("Failed to reset password. Please request a new reset link.");
  } finally {
    isSubmitting.value = false;
  }
};

onMounted(resolveResetCode);

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("reset_password_view.title")), 1),
      _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("reset_password_view.sub_title")), 1),
      _createElementVNode("div", _hoisted_6, [
        (linkInvalid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("reset_password_view.invalid_link")), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_FormKit, {
          type: "form",
          id: "reset-password-form",
          actions: false,
          onSubmit: handleSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              name: "email",
              type: "email",
              label: _ctx.$t('reset_password_view.email_label'),
              "outer-class": "my-4",
              "input-class": "h-11 mt-1",
              placeholder: _ctx.$t('reset_password_view.email_placeholder'),
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              disabled: ""
            }, null, 8, ["label", "placeholder", "modelValue"]),
            _createVNode(_component_FormKit, {
              name: "password",
              type: "password",
              label: _ctx.$t('reset_password_view.password_label'),
              validation: "required|length:6",
              "outer-class": "mt-4",
              "input-class": "h-11 pr-[3%] mt-1",
              placeholder: _ctx.$t('reset_password_view.password_placeholder'),
              "validation-messages": {
              required: _ctx.$t('reset_password_view.password_required'),
              length: _ctx.$t('reset_password_view.password_length'),
            }
            }, null, 8, ["label", "placeholder", "validation-messages"]),
            _createVNode(_component_FormKit, {
              name: "password_confirm",
              type: "password",
              label: _ctx.$t('reset_password_view.confirm_password_label'),
              validation: "required|confirm",
              "outer-class": "mt-4",
              "input-class": "h-11 pr-[3%] mt-1",
              placeholder: _ctx.$t('reset_password_view.confirm_password_placeholder'),
              "validation-messages": {
              required: _ctx.$t('reset_password_view.confirm_password_required'),
              confirm: _ctx.$t('reset_password_view.confirm_password_confirm'),
            },
              "validation-visibility": "dirty"
            }, null, 8, ["label", "placeholder", "validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "submit",
              class: "w-full h-11 opacity-50 font-semibold text-base text-white rounded-[20px] mt-6",
              inputClass: "mt-4 px-6 py-[10px]",
              disabled: linkInvalid.value
            }, {
              default: _withCtx(() => [
                (isSubmitting.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("reset_password_view.btn_resetting")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("reset_password_view.btn_reset")), 1))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$t("reset_password_view.back_to_login")) + " ", 1),
            _createElementVNode("a", {
              onClick: goToLogin,
              class: "text-sm cursor-pointer font-semibold text-blue-600"
            }, _toDisplayString(_ctx.$t("reset_password_view.login")), 1)
          ])
        ]),
        (linkInvalid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "text-sm font-semibold text-blue-600",
                onClick: goToForgotPassword
              }, _toDisplayString(_ctx.$t("reset_password_view.request_new")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", {
          class: "text-gray-600 font-normal text-sm",
          innerHTML: _ctx.$t('reset_password_view.email')
        }, null, 8, _hoisted_14)
      ])
    ]),
    _hoisted_15
  ]))
}
}

})